import React, { Component } from "react";

import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";

import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { ButtonGroup, Button, Box, Typography, FormGroup, AppBar, Paper, IconButton } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import * as RFIcon from 'react-feather'; 
import language from "../../languages";

const useStyles = makeStyles((theme) => ({
    choices: {
        paddingLeft: 10
    },
    choicesLabel: {
        fontSize: 14
    },
    closeFilter: {
        float: 'right',
        bottom: 5
    }
}));


export default function BaseFilter(props) {
    const { filterObj, handleFilter, showFilterToggle, lang } = props;
    const classes = useStyles();
    const filterComp = filterObj.map((filterRow, j) => {
        if (filterRow.type === 'radio') {
            return <React.Fragment key={j}>
                <Typography variant="subtitle2">{filterRow.label}</Typography>
                <RadioGroup aria-label={filterRow.label} name={filterRow.name} onChange={handleFilter} className={classes.choices}>
                    {
                        filterRow.items.map((item,i) => 
                            <FormControlLabel key={i} value={item.value} 
                                control={<Radio size='small' checked={item.selected} />}
                                label={<Typography className={classes.choicesLabel} variant="subtitle1" >{item.label}</Typography>} />)
                    }
                </RadioGroup>
                <br/>
            </React.Fragment>
        } else if (filterRow.type === 'checkbox') {
            return <React.Fragment key={j}>
                <Typography variant="subtitle2">{filterRow.label}</Typography>
                <FormGroup className={classes.choices}>
                    {filterRow.items.map((item, i) => <FormControlLabel key={i}
                        control={<Checkbox size='small' onChange={handleFilter} name={filterRow.name} checked={item.selected} />}
                        label={<Typography className={classes.choicesLabel} variant="subtitle1" >{item.label}</Typography>} value={item.value}
                    />)
                    }
                </FormGroup>
                <br/>
            </React.Fragment>
        }
    })
    return (             
        <Box>
            <Box p={2}>
                <Typography  variant="h6" noWrap>
                    {language[lang].Filters}
                    <IconButton onClick={() => showFilterToggle(false)} className={classes.closeFilter}>
                        <RFIcon.X strokeWidth={3} color="black" size={20} />
                    </IconButton>
                </Typography> 
                
                <FormControl component="fieldset">
                    {filterComp}
                </FormControl>
            </Box>
            
            {/* <Box p={2}>
                <ButtonGroup
                    fullWidth
                    orientation="horizontal"
                    variant="contained"
                    spacing={2}
                >
                  <Button onClick={props.resetFilter} color="secondary">Reset</Button>
                  <Button onClick={props.doFilter} color="primary">Filter</Button>
                </ButtonGroup>
            </Box> */}
        </Box>
    )
}
